import { Injectable } from "@angular/core";

function _window() : any {
    return window;
}
 
@Injectable()
export class windowService{

    get nativeWindow() : any {
        return _window();
    }
    
}